import { SearchQueryFilterType } from '@/core/search/model/search';

const SPECIAL_LABELS: Partial<Record<SearchQueryFilterType, string>> = {
  pdf: 'PDFs',
  genre: 'Article series',
};

export function getSearchTypeLabel(type: SearchQueryFilterType): string {
  return SPECIAL_LABELS[type] ?? `${type[0].toUpperCase()}${type.slice(1)}s`;
}
